<script>
	import { Material } from "@xbs/svelte-wx";

	const SLOTS = $$slots;

</script>

{#if SLOTS && SLOTS.default}
	<Material>
		<slot />
	</Material>
{/if}

<style global>
	.wx-material-theme * {
		box-sizing: border-box;
	}
	.wx-material-theme,
	.wx-portal {
		--wx-font: var(--wx-font-weight) var(--wx-font-size)
			var(--wx-font-family);
		--wx-icon-color-hover: var(--wx-background-hover);

		--wx-kanban-background: #f1f1f1;
		--wx-kanban-background-light: #fff;
		--wx-border-color: #dfdfdf;

		/* set wx variables */
		--wx-color-primary: #2a7fff;
		--wx-font-size: 14px;
		--wx-font-size-md: 15px;
		--wx-font-size-sm: 12px;

		--wx-padding: 12px;
		--wx-border: 1px solid var(--wx-border-color);

		--wx-popup-background: var(--wx-kanban-background-light);
		--wx-field-width: 100%;

		--wx-background: var(--wx-kanban-background-light);
		--wx-background-hover: var(--wx-kanban-background);
		/* end set wx variables */

		/* Kanban */
		--wx-kanban-column-width: 300px;
		--wx-kanban-column-height: 300px;

		--wx-kanban-toolbar-height: 56px;
		--wx-kanban-toolbar-align: center;
		--wx-kanban-toolbar-justify: flex-start;

		--wx-kanban-toolbar-control-hover: rgba(0, 0, 0, 0.07);
		--wx-kanban-toolbar-control-active: rgba(0, 0, 0, 0.15);

		--wx-kanban-column-header-height: 44px;

		--wx-kanban-card-field-padding: 12px;
		--wx-kanban-card-background: var(--wx-kanban-background-light);
		--wx-kanban-card-border: var(--wx-border);
		--wx-kanban-card-border-radius: 6px;

		--wx-kanban-user-icon-size: 40px;

		--wx-kanban-header-height: 68px;
		--wx-kanban-editor-width: 300px;

		--wx-kanban-over-limit-color: var(--wx-color-danger);
		--wx-kanban-collapsed-column-width: 44px;
		--wx-kanban-z-index: 1;

		--wx-progress-height: 4px;

		--wx-kanban-menu-color: rgba(0, 0, 0, 0.7);
		--wx-kanban-menu-min-width: 100px;
		/* End Kanban */
	}

	.wx-styled-scroll {
		--wx-styled-scroll-track-color: #fafafa;
		--wx-styled-scroll-thumb-color: #babac0;
		--wx-styled-scroll-width: 16px;
	}
	.wx-styled-scroll * {
		scrollbar-width: thin;
	}
	.wx-styled-scroll *::-webkit-scrollbar {
		width: var(--wx-styled-scroll-width);
	}
	.wx-styled-scroll *::-webkit-scrollbar-track {
		background-color: var(--wx-styled-scroll-track-color);
	}
	.wx-styled-scroll *::-webkit-scrollbar-thumb {
		background-color: var(--wx-styled-scroll-thumb-color);
		border-radius: var(--wx-styled-scroll-width);
		border: 4px solid var(--wx-styled-scroll-track-color);
	}
	.wx-styled-scroll *::-webkit-scrollbar-button {
		display: none;
	}

</style>
